import { Link, NavLink, Outlet } from "react-router";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "../../public/IMG_1579.JPG";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/menu", label: "Menu" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground selection:bg-primary selection:text-primary-foreground">
      <header className="sticky top-0 z-50 border-b border-white/5 bg-background/80 backdrop-blur-md supports-[backdrop-filter]:bg-background/60">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-6 py-4">
          <Link to="/" className="flex items-center gap-4">
            <img
              src={logo}
              alt="Miss T's"
              className="size-10 rounded-full object-cover border border-primary/30"
            />
            <div>
              <p className="text-[10px] uppercase tracking-[0.4em] text-primary">
                Miss T's
              </p>
              <p className="font-serif text-lg leading-none text-foreground">
                Home Bakery
              </p>
            </div>
          </Link>
          <nav className="flex flex-wrap items-center gap-6 text-sm font-medium text-muted-foreground">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `transition-colors hover:text-primary ${isActive ? "text-primary" : ""}`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Button
              asChild
              size="sm"
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground font-medium tracking-wide"
            >
              <Link to="/plan-pickup">Plan Pickup</Link>
            </Button>
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-white/10 bg-black/20">
        <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-12 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-col gap-1">
            <span className="font-serif text-lg text-foreground">
              &copy; {new Date().getFullYear()} Miss T's Home Bakery.
            </span>
            <span>Baked with love.</span>
          </div>
          <div className="flex gap-8">
            <a
              className="transition hover:text-primary flex items-center gap-2"
              href="https://wa.me/18192133065"
              target="_blank"
              rel="noreferrer"
            >
              <Phone className="size-4" />
              819-213-3065
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
